export { IxIcon } from './IxIcon.js';
